// utility function used to compose tracking data
module.exports = (...configs) => {
    return configs.reduce((prev, curr) => {
        return Object.assign({}, prev, curr);
    });
}



// WEBPACK FOOTER //
// ./app/lib/util/compose.js